import { State } from '@cemex/cmx-client-layout';
import { createFeatureSelector } from '@ngrx/store';
import * as fromCxApiMetadata from './cx-api-metadata.reducer';

export const cxApiMetadataKey = 'cxApiMetadata';
export const reducers = fromCxApiMetadata.reducer;

export interface CxApiMetadataState extends State {
  [cxApiMetadataKey]: fromCxApiMetadata.CxApiMetadataState;
}

export const selectApiMetadataState = createFeatureSelector<fromCxApiMetadata.CxApiMetadataState>(cxApiMetadataKey);
